import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ServerResponse } from './types';
import config from 'config/config';
import { setVendorData } from 'store/vendorSlice';

export const eventsApiSlice = createApi({
  reducerPath: 'events',
  baseQuery: fetchBaseQuery({ baseUrl: config.apiUrl }),
  endpoints: builder => ({
    getEventsByVendorId: builder.query<
      ServerResponse,
      { vendorId: string; page: number }
    >({
      query: ({ vendorId, page }) =>
        `vendor/${vendorId}/events?page=${page}&include=type,timeInterval,dateTimeFormat,location,cover,currency,minmaxticketsprices,fees_and_taxes,publicInformation`,
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge: (currentCache, newData) => {
        newData.events.forEach(newEvent => {
          const eventIndexInsideCache = currentCache.events.findIndex(
            cachedEvent => cachedEvent.id === newEvent.id,
          );

          if (eventIndexInsideCache === -1) {
            currentCache.events.push(newEvent);
          } else {
            currentCache.events[eventIndexInsideCache] = { ...newEvent };
          }
        });
        currentCache.remainingEvents = newData.remainingEvents;
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.page !== previousArg?.page;
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setVendorData(data.vendor));
        } catch (err) {}
      },
    }),
  }),
});

export const { useGetEventsByVendorIdQuery, usePrefetch } = eventsApiSlice;
